import { isArray } from "lodash-es";
import Select, { type MenuPosition } from "react-select";

import { type KeyLabel } from "../../../graphql.js";
import { type IAdvancedSearchFieldProps } from "./AdvancedSearchCriteria.js";

/**
 * Select input for controlled vocabulary list in advanced search criteria.
 */
export default function AdvancedSearchSelect(props: IAdvancedSearchFieldProps & { menuPosition?: MenuPosition }) {
  // TODO: A good idea would be to use the extracted "defaulted" component from the Advanced Search
  //       It has the same kind of default values and it will avoid duplicates
  return (
    <div style={{ flex: 1 }}>
      <Select
        className={"react-select"}
        classNamePrefix={"react-select"}
        value={
          props.filterOperation.value &&
          isArray(props.filterOperation.value) &&
          props.filterOperation.value.map((value: string) => ({
            key: value,
            label: value,
          }))
        }
        getOptionValue={(option: KeyLabel) => option?.key}
        isMulti={true}
        placeholder={"Select one or more values"}
        options={props.field.searchAttribute.values}
        onChange={(option: KeyLabel[]) => {
          props.onChangeState({ value: option?.map((innerOption: KeyLabel) => innerOption.key) });
        }}
        onBlur={props.onBlur}
        autoFocus={props.autoFocus}
        closeMenuOnSelect={true}
        maxMenuHeight={180}
        menuPosition={props.menuPosition ?? "fixed"}
        isClearable={false} // SEL6-5177 - somehow clicking the clear cross icon does lead to the closing of the react-aria overlay
      />
    </div>
  );
}
